var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMountains(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#222",
    className: "stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.5 15.389h19"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.415 14.777 9.17 7.642l-4.948 7.135",
    stroke: "#222",
    className: "stroke",
    strokeWidth: 0.9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m6.77 11.317 1.275 1.061 1.274-1.184 1.42 1.184 1.128-.98M19.97 14.777l-4.1-5.58-2.76 3.914",
    stroke: "#222",
    className: "stroke",
    strokeWidth: 0.9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m13.992 12.071.996.83.997-.925 1.111.925.881-.766M19.681 8.948c.56 0 1.015-.436 1.015-.974S20.242 7 19.68 7c-.56 0-1.015.436-1.015.974s.455.974 1.015.974Z",
    stroke: "#222",
    className: "stroke",
    strokeWidth: 0.9,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountains);
export default __webpack_public_path__ + "static/media/mountains.cfc6fed1.svg";
export { ForwardRef as ReactComponent };